import vietnameseMessages from 'ra-language-vietnamese'
import englishMessages from 'ra-language-english'
import chineseMessages from '@haxqer/ra-language-chinese'
// import chineseMessages from 'ra-language-chinese'

import { vi } from './locales/vi'
import { en } from './locales/en'
import { zh } from './locales/zh'

// Merge React Admin messages with custom translations
const messages = {
  vi: {
    ...vietnameseMessages,
    ...vi,
    resources: {
      ...vietnameseMessages.resources,
      ...vi.resources,
    },
  },
  en: {
    ...englishMessages,
    ...en,
    resources: {
      ...en.resources,
    },
  },
  zh: {
    ...chineseMessages,
    ...zh,
    resources: {
      ...zh.resources,
    },
  },
}

// App dùng I18nContext + appLocaleMessages — không gọi ra-i18n-polyglot
// (new Polyglot lỗi "is not a constructor" khi build production webpack).

// Export individual locales for direct use
export { vi, en, zh }

/** Locale messages merged with React Admin (dùng cho I18nContext). */
export const appLocaleMessages = messages

// Export available locales configuration
export const availableLocales = [
  {
    code: 'vi',
    name: 'Tiếng Việt',
    flag: '🇻🇳',
    nativeName: 'Tiếng Việt',
  },
  {
    code: 'en',
    name: 'English',
    flag: '🇺🇸',
    nativeName: 'English',
  },
  {
    code: 'zh',
    name: '中文',
    flag: '🇨🇳',
    nativeName: '简体中文',
  },
]

// Helper function to get locale native name
export const getLocaleNativeName = (code: string): string => {
  const locale = availableLocales.find((l) => l.code === code)
  return locale ? locale.nativeName : code
}

// Validation function to check if locale is supported
export const isSupportedLocale = (code: string): boolean => {
  return availableLocales.some((l) => l.code === code)
}

// Get default locale
export const getDefaultLocale = (): string => {
  return 'vi'
}

// For debugging - check translation coverage
export const getTranslationStats = () => {
  const stats = {}

  Object.keys(messages).forEach((locale) => {
    const messageObj = messages[locale]
    const keyCount = countKeys(messageObj)
    stats[locale] = {
      totalKeys: keyCount,
      hasResources: !!messageObj.resources,
      hasAuth: !!messageObj.auth,
      hasNavigation: !!messageObj.navigation,
      hasCommon: !!messageObj.common,
    }
  })

  return stats
}

// Helper function to count nested keys
const countKeys = (obj: any, depth = 0): number => {
  if (depth > 10) return 0 // Prevent infinite recursion

  let count = 0
  for (const key in obj) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      count += countKeys(obj[key], depth + 1)
    } else {
      count++
    }
  }
  return count
}

// Export for debugging in development
// if (process.env.NODE_ENV === 'development') {
//   console.log('Translation stats:', getTranslationStats())
// }
